import api from './api';

// Yemekhane SELF-SERVİS uçları — hepsi `v1/my-meals` altında ([Authorize]-only +
// [RequireActiveModule("CN")]). Eskiden /my-meals sayfaları YÖNETİM uçlarını
// çağırıyordu (/v1/meal-entries/my, /v1/canteen-settings, /v1/meal-menus*) ve o
// controller'lar sınıf düzeyinde [ModuleAuthorize("CN","Read")] taşıdığı için
// menü görünüyor ama sayfa 403 veriyordu: MenuConfig `my-meals`i self-servis
// olarak listelemesine rağmen `privileges: ['CN.Read']` istiyordu.
//
// Bu dosyadan YÖNETİM ucu çağrılmaz. Yönetim çağrıları mealEntryService /
// mealMenuService / canteenSettingsService'te kalır.

// Çalışanın kendi yemek kayıtları.
export const getMyMealEntries = (params) => api.get('/v1/my-meals/entries', { params });

// Ekranda gösterilen günlük/aylık limit (yönetim ayar DTO'sunun tamamı değil).
export const getMyMealLimits = () => api.get('/v1/my-meals/limits');

// Tek günün menüsü.
export const getMyMealMenusByDate = (date) => api.get(`/v1/my-meals/menus/by-date/${date}`);

// Haftalık menü. `from`/`to` sunucuda GERÇEKTEN uygulanır — eski çağrı
// (/v1/meal-menus?menuDateGte=…) bracket-notation beklendiği için tarih
// süzgecini SESSİZCE hiç uygulamıyor, kiracının ilk 500 menüsünü döndürüyordu.
export const getMyMealMenus = (from, to) => api.get('/v1/my-meals/menus', { params: { from, to } });

// Yemekhane turnikesi QR okutma (çağıranın kendi kaydını yazar).
export const scanMeal = (data) => api.post('/v1/my-meals/scan', data);
